<!-- 没有手风琴效果的，每一个都独立互相不影响 -->
<template>
  <el-collapse class="component-collapse-menu-picker" v-bind="$attrs">
    <el-collapse-item>
      <template #title>
        <template v-if="!$slots.title">
          <div class="title">
            {{ title }}
          </div>
          <svg
            class="svgfont icon"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            width="512"
            height="512"
            viewBox="0 0 512 512"
          >
            <path fill="currentColor" d="M508 112l-252 288-252-288h504z"></path>
          </svg>
        </template>
        <template v-else>
          <slot name="title" />
        </template>
      </template>

      <template #default>
        <template v-if="!$slots.default">
          <SensorTrack class="item" :datas="item.sensorData" v-for="(item, index) in list" :key="index">
            <nuxt-link-enhance
              class="link"
              :project="item.project"
              :to="item.to"
              :replace="item.replace"
              @click.native="onSelect(item)"
            >
              <span class="name">
                {{ $t(item.name) }}
              </span>
            </nuxt-link-enhance>
          </SensorTrack>
        </template>
        <template v-else>
          <slot name="default" />
        </template>
      </template>
    </el-collapse-item>
  </el-collapse>
</template>

<script>
import commonMixins from '../NavigatorBar/mixins'
import SensorTrack from '../NavigatorBar/components/SensorTrack'
import NuxtLinkEnhance from '../NavigatorBar/components/NuxtLinkEnhance'

export default {
  name: 'ComponentsCollapseMenuPicker',
  components: {
    SensorTrack,
    NuxtLinkEnhance,
  },

  mixins: [commonMixins],
  props: {
    title: {
      type: String,
      default: '',
    },
    list: {
      type: Array,
      default() {
        return []
      },
    },
  },

  methods: {
    onSelect(item) {
      if (!item.to) {
        this.$emit('select', item.value)
      }
    },
  },
}
</script>

<style lang="less" scoped>
@import '@/common/css/tailwind.css';
@import '@/common/css/ui.variables.less';
.component-collapse-menu-picker {
  border: none;
  * {
    box-sizing: border-box;
  }

  .title {
    box-sizing: border-box;
    display: flex;
    align-items: center;
    flex: 1 1 0%;
    height: 70px;
    padding-top: 24px;
    padding-bottom: 24px;
    font-size: 16px; /* 14px */
    line-height: 22px;
    font-weight: 500;
    cursor: pointer;
  }

  .item {
    display: flex;
    flex-direction: column;

    &:first-of-type {
      .name {
        padding-top: 0;
      }
    }
    &:last-of-type {
      .name {
        padding-bottom: 24px;
      }
    }
  }

  .name {
    padding-top: 12px;
    padding-bottom: 12px;
    font-size: 14px;
    line-height: 18px;
    align-items: center;
    cursor: pointer;
    display: flex;
    box-sizing: border-box;
  }

  .icon {
    font-size: 8px;
    right: 16px;
    position: absolute;
  }

  :deep(.el-collapse-item__arrow) {
    display: none;
  }

  :deep(.el-collapse-item__content) {
    padding-bottom: 0;
  }

  :deep(.el-collapse-item__header) {
    position: relative;
    border-bottom: none;
    height: auto;
    font-weight: 600;
    font-size: 14px;
    line-height: 24px;

    .svgfont {
      transition: transform 0.25s cubic-bezier(0.645, 0.045, 0.355, 1);
      transform: rotate(0deg);
    }

    &.is-active {
      .svgfont {
        transform: rotate(180deg);
      }
    }
  }

  :deep(.el-collapse-item__wrap) {
    border-bottom: none;
  }

  :deep(.el-collapse-item:last-child) {
    margin-bottom: 0;
  }
}
</style>
